
    import * as React from 'react';

    const CheckboxChecked12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><g fillRule="evenodd"><path d="M1.125 10.875h9.75v-9.75h-9.75v9.75zm.75-.75v-8.25h8.25v8.25h-8.25z" fillRule="nonzero" /><path d="M6 8.5a2.5 2.5 0 10-.002-5.002A2.5 2.5 0 006 8.5" /></g></svg>
        </div>
      );
    };

    CheckboxChecked12.displayName = 'CheckboxChecked12';

    export default CheckboxChecked12;
  